import API from 'aurora-api';
import * as urls from 'aurora-api/urls';
import { ACTIVE_URL } from 'aurora-utils/constants';

const { BASE_URL } = ACTIVE_URL;

const api = new API(`${BASE_URL}/workflow-service`);
class TasksService {
  // static fetchTasks = () => api.get(urls.PROJECTION.TASKS, null);

  static fetchTasks = (page = 1, size = 5, data) => {
    const baseURL = `/api/v1/application/search?sort=create_timestamp&page=${page}&size=${size}`;
    const url = baseURL;
    // const reqParams = {};
    // if (id) {
    //   reqParams.applicationNumber = id;
    // } else if (filter && filter !== 'ALL') {
    //   const statusArray = [];
    //   statusArray.push(filter);
    //   reqParams.progressStatusList = statusArray;
    // }
    return api.post(url, data || {});
  };

  static fetchTaskList = (page = 1, size = 5, data) => {
    const url = `${urls.PROJECTION.TASK_LIST}/search?sort=createTimestamp&page=${page}&size=${size}`;
    return api.post(url, data || {});
  };

  static fetchTask = (filter, page = 0, size = 5) => {
    const payload = {
      ...filter,
      taskStatus: filter.status || filter.taskStatus,
    };
    delete payload.status;
    const url = `${urls.PROJECTION.TASK_LIST}/search?sort=createTimestamp&page=${page}&size=${size}`;
    return api.post(url, payload);
  };

  static fetchOffplanTerminationTask = () => {
    const url = urls.PROJECTION.OFF_PLAN_TERMINATION_TASK_LIST;
    return api.get(url);
  };
}

export default TasksService;
